import { getUnitsByFeatures } from './units';

/**
 * Förbered district data för att spara
 * @param {Object} params - Save parameters
 * @param {Object} params.selectedAreas - Selected areas structure från state
 * @param {Object} params.district - District object från state
 * @param {Array} params.selectedAreasFeatures - Array av GeoJSON features från mapState
 * @param {Array} params.units - Units array
 * @param {Object} params.drawingManager - DrawingManager instance
 * @param {string} params.name - District name
 * @param {string} params.color - District color
 * @param {boolean} params.addWatcher - Add watcher flag
 * @param {string} params.type - District type
 * @returns {Object} Prepared district data
 */
export function prepareDistrictDataForSave({
    selectedAreas,
    district,
    selectedAreasFeatures,
    units,
    drawingManager,
    name,
    color,
    addWatcher,
    type
}) {
    const { spatialGeoJson, ...selectedAreasRest } = selectedAreas;
    
    // Uppdatera spatialGeoJson properties
    const updatedSpatialGeoJson = {
        ...spatialGeoJson,
        properties: {
            ...spatialGeoJson.properties,
            color,
            name
        }
    };

    // Filtrera units i valda områden
    const filteredUnitsInArea = getUnitsByFeatures(selectedAreasFeatures, units);

    // Förbered home marker GeoJSON
    const homeMarkerGeoJson = drawingManager.houseMarker 
        ? JSON.stringify([drawingManager.houseMarker.getGeoJSON()]) 
        : '';

    // Bygg district data objekt
    const districtData = {
        ...district,
        ...selectedAreasRest,
        units: filteredUnitsInArea.map(m => m.companyId),
        name,
        color,
        addWatcher,
        homeMarkerGeoJson,
        spatialGeoJson: JSON.stringify([updatedSpatialGeoJson]),
        type
    };

    return districtData;
}

/**
 * Navigera till district detail page efter save
 * @param {Object} result - Save result från API
 * @param {string} type - District type ('retail' eller 'foodservice')
 * @param {string} scenarioId - Scenario ID
 */
export function navigateToDistrictAfterSave(result, type, scenarioId) {
    const basePath = type === 'foodservice' 
        ? `/foodservice-scenario/${scenarioId}/district/${result.id}` 
        : `/scenario/${scenarioId}/district/${result.id}`;
    
    setTimeout(() => {
        window.location.href = basePath;
    }, 1000);
}

